module.exports = __webpack_public_path__ + "static/media/crops.f54d1db3.png";